import classNames from "classnames";
import React, { useState } from "react";

import { TBettingTypeGroup } from "@state/stores/offer/event/EventViewStore";
import { BettingTypeGroupBody } from "./BettingTypeGroupBody";
import BettingTypeGroupHeader from "./BettingTypeGroupHeader";

export function BettingTypeGroup(props: {
	group: TBettingTypeGroup;
	isFavorite?: boolean;
}) {
	const { group, isFavorite } = props;

	const [isExpanded, setExpand] = useState(true);

	const containerElClasses = classNames("offer offer--additional", {
		"is-collapsed": !isExpanded,
	});

	return (
		<div className={containerElClasses}>
			<BettingTypeGroupHeader
				isExpanded={isExpanded}
				onSetExpand={setExpand}
				group={group}
				isFavorite={isFavorite}
			/>
			<BettingTypeGroupBody
				isExpanded={isExpanded}
				group={group}
				isFavorite={isFavorite}
			/>
		</div>
	);
}
